import { createStyles, makeStyles } from "@material-ui/core/styles";
import Pagination, {
  PaginationRenderItemParams,
} from "@material-ui/lab/Pagination";
import { AxiosError, AxiosResponse } from "axios";
import _ from "lodash";
import React, { useEffect, useState } from "react";
// import globalStyles from "styles/globalStyles";
// import { IListMetaData } from "types/listtable";
// import { IResponse } from "types/response";
// import { initPager } from "../../../constants/dummyRequests";
// import useHandleError from "../../../hooks/useHandleError";
// import paginationStyles from "../../../styles/components/paginationStyles";
// import { IPager } from "../../../types/Pagination";
// import { IRequests } from "../../../types/requests";

const useStyles1 = makeStyles((theme) =>
  createStyles({
    root: {
      flexShrink: 0,
      marginLeft: theme.spacing(2.5),
    },
    disableRipple: {
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "transparent",
      },
    },
    selectRootPagination: {
      marginTop: theme.spacing(7),
      display: "flex",
      justifyContent: "flex-end",
    },
  }),
);

const paginationStyles = makeStyles((theme) =>
  createStyles({
    paginationRoot: {
      fontSize: 15,
      "& .previous": {
        color: "#3A434B",
        fontWeight: "normal",
        marginRight: 8,
        cursor: "pointer",
      },
      "& .next": {
        color: "#3A434B",
        fontWeight: "normal",
        marginLeft: 8,
        cursor: "pointer",
      },
      "& .page": {
        marginLeft: 8,
        marginRight: 8,
        cursor: "pointer",
      },
      "& .page-selected": {
        backgroundColor: "#E8EFFD",
        color: "#1354D3",
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 3,
        paddingBottom: 3,
        fontWeight: 400,
        cursor: "pointer",
      },
    },
  }),
);

const initPager = {
  totalItems: 0,
  currentPage: 0,
  pageSize: 10,
  totalPages: 0,
  startPage: 1,
  endPage: 0,
  startIndex: 0,
  endIndex: 0,
  pages: [],
  loadingItems: true,
  errorInLoading: false,
};

// interface StellasPaginationApiProps<T> {
//   items?: T[];
//   itemsCount: number;
//   handleChangePageParent: (
//     newPage: number,
//     pageOfItems: any,
//     pager: IPager,
//   ) => void;
//   searchData: any;
//   service: (searchData: IRequests) => Promise<AxiosResponse<IResponse<T[]>>>;
//   updateSearch: (listMetaData: IListMetaData) => void;
//   listMetaData?: IListMetaData;
//   refresh?: boolean;
// }
export default function VigilearnPaginationApi({
  refresh,
  listMetaData,
  service,
  searchData,
  updateSearch,
  itemsCount,
  handleChangePageParent,
}) {
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [pager, setPager] = useState(initPager);
  const classes = useStyles1();
  const paginationClasses = paginationStyles();
  // const { handleAppError } = useHandleError();
  const getPager = (
    totalPages,
    totalItems,
    currentPage = 1,
    pageSize,
    itemsCount,
  ) => {
    // default to first page
    currentPage = currentPage;
    // debugger
    // default page size is 10
    pageSize = pageSize || itemsCount;

    // calculate total pages
    var totalPages = Math.ceil(totalItems / pageSize);

    let startPage, endPage;
    if (totalPages <= itemsCount) {
      // less than 10 total pages so show all
      startPage = 1;
      endPage = totalPages;
    } else {
      // more than 10 total pages so calculate start and end pages
      if (currentPage <= 6) {
        startPage = 1;
        endPage = itemsCount;
      } else if (currentPage + 4 >= totalPages) {
        startPage = totalPages - 9;
        endPage = totalPages;
      } else {
        startPage = currentPage - 5;
        endPage = currentPage + 4;
      }
    }

    // calculate start and end item indexes
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

    // create an array of pages to ng-repeat in the pager control
    const pages = _.range(startPage, endPage + 1);

    // return object with all pager properties required by the view
    return {
      totalItems,
      currentPage,
      pageSize,
      totalPages,
      startPage,
      endPage,
      startIndex,
      endIndex,
      pages,
    };
  };

  const handleChangePage = (
    event,
    newPage
  ) => {
    setPage(newPage);
    const newSearchData = {
      ...searchData,
      pageIndex: newPage,
    };

    updateSearch({ isError: false, isSearching: true });
    service(newSearchData)
      .then((res) => {
        console.log('res.......................', newSearchData, res);
        if (res.data.hasErrors) {
          updateSearch({ isError: true, isSearching: false });
          const newPager = getPager(
            res.data.payload.totalPages,
            res.data.payload.totalSize,
            newPage,
            searchData?.pageSize ?? rowsPerPage,
            searchData?.pageSize ?? rowsPerPage,
          );
          setPager(newPager);
          const pageOfItems = res.data.payload.items;
          // call change page function in parent component
          handleChangePageParent(newPage, pageOfItems, newPager);
        } else {
          const newPager = getPager(
            res.data.payload.totalPages,
            res.data.payload.totalSize,
            newPage,
            searchData?.pageSize ?? rowsPerPage,
            searchData?.pageSize ?? rowsPerPage,
          );
          setPager(newPager);
          const pageOfItems = res.data.payload.items;
          updateSearch({ isError: false, isSearching: false });

          // call change page function in parent component
          handleChangePageParent(newPage, pageOfItems, newPager);
        }
      })
      .catch((axiosError) => {
        // C O M E  B A C K  H E R E  T O  U P D A T E  T H E  E R R O R  H A N D L E R 

        // handleAppError(axiosError, null);
        updateSearch({ isError: true, isSearching: false });
      });
  };

  const renderCustomPagination = (params) => {
    const { page, type, selected } = params;
    let children = null;
    if (type === "start-ellipsis" || type === "end-ellipsis") {
      children = "…";
    } else if (type === "page") {
      children = (
        <div className={`page ${selected && "page-selected"}`} {...params}>
          {page}
        </div>
      );
    } else {
      if (type === "previous") {
        children = (
          <div {...params} className="previous">
            Prev
          </div>
        );
      } else if (type === "next") {
        children = (
          <div {...params} className="next">
            Next
          </div>
        );
      }
    }
    return (
      <div key={_.uniqueId()} className={paginationClasses.paginationRoot}>
        {children}
      </div>
    );
  };

  useEffect(() => {
    handleChangePage(null, 1);
  }, []);

  useEffect(() => {
    if (refresh && refresh === true) {
      handleChangePage(null, 1);
    }
  }, [refresh]);

  useEffect(() => {
    const newSearchData = {
      ...searchData,
      searchWord: searchData.searchWord,
    };

    if (searchData && searchData.searching === true) {
      updateSearch({ isError: false, isSearching: true });
      service(newSearchData)
        .then((res) => {
          console.log('res.......................', newSearchData, res);
          const pager = getPager(
            res.data.payload.totalPages,
            res.data.payload.totalSize,
            1,
            searchData?.pageSize ?? rowsPerPage,
            searchData?.pageSize ?? rowsPerPage,
          );
          setPager(pager);
          const pageOfItems = res.data.payload.items;
          updateSearch({ isError: false, isSearching: false });
          // call change page function in parent component
          handleChangePageParent(1, pageOfItems, pager);
        })
        .catch(() => {
          updateSearch({ isError: true, isSearching: false });
        });
    }
    if (searchData?.refresh === true) {
      updateSearch({ isError: false, isSearching: true });
      service(newSearchData)
        .then((res) => {
          const pager = getPager(
            res.data.payload.totalPages,
            res.data.payload.totalSize,
            1,
            searchData?.pageSize ?? rowsPerPage,
            searchData?.pageSize ?? rowsPerPage,
          );
          setPager(pager);
          const pageOfItems = res.data.payload.items;
          updateSearch({ isError: false, isSearching: false });
          // call change page function in parent component
          handleChangePageParent(1, pageOfItems, pager);
        })
        .catch(() => {
          updateSearch({ isError: true, isSearching: false });
        });
    }
  }, [searchData]);

  return (
    <>
      {itemsCount > 10 && (
        <>
          {!listMetaData?.isError && (
            <Pagination
              count={pager?.pages.length}
              page={page}
              renderItem={renderCustomPagination}
              onChange={handleChangePage}
              className={classes.selectRootPagination}
            />
          )}
        </>
      )}
    </>
  );
}
